import './ProductDeliveryOptions.style.scss';

import { PureComponent } from 'react';

import Link from 'Component/Link';


export class ProductDeliveryOptions extends PureComponent {
    renderFreeDelivery() {
        const { threshold, grand_total, default_display_currency_code } = this.props;

        if (grand_total > threshold) {
            return (
                <p><strong>{ __('Free shipping') }</strong>, <span>{ __('available for your order') }</span></p>
            )
        }

        return (
            <p>
                {`${ __('Free delivery') } ${ __('from %s %s', threshold, formatCurrency(default_display_currency_code)) }. `}
                <Link to={ __('/page/shipment') } target="_blank">{ __('See details') }</Link>
            </p>
        )
    }

    render() {
        const { delivery_dates: { details }, threshold, grand_total, stock_status, salable_quantity_oos, attributes, code } = this.props;

        if (salable_quantity_oos) {
            return null;
        }

        if (details.length === 0) {
            return null;
        }

        const check_color = grand_total > threshold ? '#4BCC65' : '#747081';

        return (
            <div block="ProductDeliveryOptions">
                <div block="PictureContainer">
                    <svg xmlns="http://www.w3.org/2000/svg" width="75.354" height="47.667" viewBox="0 0 75.354 47.667" fill={ check_color }><g transform="translate(0 -94.062)"><g transform="translate(0 94.062)"><g transform="translate(0 0)"><path d="M70.079,114.27l-1.951-7.806a1.18,1.18,0,0,0,.934-1.154v-1.258A4.961,4.961,0,0,0,64.106,99.1H55.218V96.5a2.441,2.441,0,0,0-2.438-2.438H7.472A2.441,2.441,0,0,0,5.034,96.5v21.4a1.18,1.18,0,1,0,2.36,0V96.5a.079.079,0,0,1,.079-.079H52.78a.079.079,0,0,1,.079.079v21.4a1.18,1.18,0,1,0,2.36,0v-1.338H69.143a3.861,3.861,0,0,1,3.666,2.674H69.14a1.18,1.18,0,0,0-1.18,1.18v2.517a3.7,3.7,0,0,0,3.7,3.7h1.337v5.191H69.91a7.47,7.47,0,0,0-14.124,0h-.568V122.93a1.18,1.18,0,0,0-2.36,0v8.888H28.378a7.47,7.47,0,0,0-14.124,0H7.472a.079.079,0,0,1-.079-.079v-2.6h5.113a1.18,1.18,0,0,0,0-2.36H1.18a1.18,1.18,0,0,0,0,2.36H5.034v2.6a2.441,2.441,0,0,0,2.438,2.438h6.373c0,.026,0,.052,0,.079a7.472,7.472,0,1,0,14.945,0c0-.026,0-.052,0-.079h26.59c0,.026,0,.052,0,.079a7.472,7.472,0,1,0,14.945,0c0-.026,0-.052,0-.079h3.856a1.18,1.18,0,0,0,1.18-1.18V120.412A6.223,6.223,0,0,0,70.079,114.27ZM55.218,101.456h8.888a2.6,2.6,0,0,1,2.6,2.6v.079H55.218Zm0,12.743V106.49H65.7l1.927,7.709Zm-33.9,25.171a5.113,5.113,0,1,1,5.113-5.113A5.119,5.119,0,0,1,21.316,139.369Zm41.532,0a5.113,5.113,0,1,1,5.113-5.113A5.119,5.119,0,0,1,62.848,139.369Zm10.147-15.1H71.658a1.339,1.339,0,0,1-1.337-1.337v-1.337h2.674v2.674Z" transform="translate(0 -94.062)"/></g></g><g transform="translate(18.878 131.818)"><g transform="translate(0 0)"><path d="M130.705,350.6a2.438,2.438,0,1,0,2.438,2.438A2.441,2.441,0,0,0,130.705,350.6Z" transform="translate(-128.267 -350.597)"/></g></g><g transform="translate(60.41 131.818)"><g transform="translate(0 0)"><path d="M412.893,350.6a2.438,2.438,0,1,0,2.438,2.438A2.441,2.441,0,0,0,412.893,350.6Z" transform="translate(-410.455 -350.597)"/></g></g><g transform="translate(30.205 126.784)"><g transform="translate(0 0)"><path d="M224.026,316.393H206.407a1.18,1.18,0,1,0,0,2.36h17.619a1.18,1.18,0,0,0,0-2.36Z" transform="translate(-205.227 -316.393)"/></g></g><g transform="translate(2.517 121.75)"><path d="M33.384,282.188h-15.1a1.18,1.18,0,1,0,0,2.36h15.1a1.18,1.18,0,1,0,0-2.36Z" transform="translate(-17.102 -282.188)"/></g><g transform="translate(21.395 105.389)"><g transform="translate(0 0)"><path d="M165,171.368a1.18,1.18,0,0,0-1.669,0l-10.493,10.492-5.458-5.458a1.18,1.18,0,1,0-1.669,1.669l6.293,6.293a1.18,1.18,0,0,0,1.668,0L165,173.037A1.18,1.18,0,0,0,165,171.368Z" transform="translate(-145.37 -171.023)"/></g></g></g></svg>
                    <div className="DeliveryPictureText">
                        { __('When will it reach you?') }
                    </div>
                </div>
                <div className="DeliveryTimes">
                    {details.map((item, index) => {
                            // Define allowed carrier types for each code
                            const allowedCarrierTypes = {
                                'default': ['Curier', 'Ridicare din easybox'],
                                'en': ['Express Delivery', 'Standard Delivery'],
                                'it': ['Spedizione Espresso', 'Spedizione Standard']
                            };

                            // Check if the item's carrier type is not allowed for the current code and skip it
                            if (!allowedCarrierTypes[code].includes(item.carrier_type)) {
                                return null;
                            }

                            if (item.carrier_type === 'Ridicare din easybox' && attributes?.no_easybox_delivery?.attribute_value === '1') {
                                return (
                                    <p key={index}>
                                        <strong>{`${item.carrier_type}: `}</strong>
                                        {__('Not available for delivery.')}
                                    </p>
                                );
                            } else if (item.carrier_type === 'Posta' && attributes?.no_postal_delivery?.attribute_value === '1') {
                                return (
                                    <p key={index}>
                                        <strong>{`${item.carrier_type}: `}</strong>
                                        {__('Not available for delivery.')}
                                    </p>
                                )
                            } else {
                                return (
                                    <p key={index}>
                                        <strong>{`${item.carrier_type}: `}</strong>
                                        {`${item.delivery_day}`}
                                        {item.delivery_date && (<>, <strong>{item.delivery_date}</strong></>)}
                                    </p>
                                );
                            }
                        })
                    }
                    { this.renderFreeDelivery() }
                </div>
            </div>
        );
    }
}

export default ProductDeliveryOptions;

const currencyMap = {
    AED: 'د.إ',
    AFN: '؋',
    ALL: 'L',
    AMD: '֏',
    ANG: 'ƒ',
    AOA: 'Kz',
    ARS: '$',
    AUD: '$',
    AWG: 'ƒ',
    AZN: '₼',
    BAM: 'KM',
    BBD: 'Bds$',
    BDT: '৳',
    BGN: 'лв',
    BHD: '.د.ب',
    BIF: 'FBu',
    BMD: '$',
    BND: 'B$',
    BOB: '$b',
    BRL: 'R$',
    BSD: 'B$',
    BTC: '฿',
    BTN: 'Nu.',
    BWP: 'P',
    BYR: 'Br',
    BYN: 'Br',
    BZD: 'BZ$',
    CAD: 'CA$',
    CDF: 'FC',
    CHF: 'CHF',
    CLP: '$',
    CNY: '¥',
    COP: '$',
    CRC: '₡',
    CUC: 'CUC$',
    CUP: '₱',
    CVE: '$',
    CZK: 'Kč',
    DJF: 'Fdj',
    DKK: 'kr',
    DOP: 'RD$',
    DZD: 'دج',
    EEK: 'kr',
    EGP: '£',
    ERN: 'Nfk',
    ETB: 'Br',
    ETH: 'Ξ',
    EUR: '€',
    FJD: 'FJ$',
    FKP: '£',
    GBP: '£',
    GEL: '₾',
    GGP: '£',
    GHC: '₵',
    GHS: 'GH₵',
    GIP: '£',
    GMD: 'D',
    GNF: 'FG',
    GTQ: 'Q',
    GYD: 'G$',
    HKD: 'HK$',
    HNL: 'L',
    HRK: 'kn',
    HTG: 'G',
    HUF: 'Ft',
    IDR: 'Rp',
    ILS: '₪',
    IMP: '£',
    INR: '₹',
    IQD: 'ع.د',
    IRR: '﷼',
    ISK: 'kr',
    JEP: '£',
    JMD: 'J$',
    JOD: 'JD',
    JPY: '¥',
    KES: 'KSh',
    KGS: 'лв',
    KHR: '៛',
    KMF: 'CF',
    KPW: '₩',
    KRW: '₩',
    KWD: 'KD',
    KYD: '$',
    KZT: 'лв',
    LAK: '₭',
    LBP: '£',
    LKR: '₨',
    LRD: 'L$',
    LSL: 'M',
    LTC: 'Ł',
    LTL: 'Lt',
    LVL: 'Ls',
    LYD: 'LD',
    MAD: 'MAD',
    MDL: 'lei',
    MGA: 'Ar',
    MKD: 'ден',
    MMK: 'K',
    MNT: '₮',
    MOP: 'MOP$',
    MRO: 'UM',
    MRU: 'UM',
    MUR: '₨',
    MVR: 'Rf',
    MWK: 'MK',
    MXN: 'Mex$',
    MYR: 'RM',
    MZN: 'MT',
    NAD: '$',
    NGN: '₦',
    NIO: 'C$',
    NOK: 'kr',
    NPR: '₨',
    NZD: '$',
    OMR: '﷼',
    PAB: 'B/.',
    PEN: 'S/.',
    PGK: 'K',
    PHP: '₱',
    PKR: '₨',
    PLN: 'zł',
    PYG: 'Gs',
    QAR: '﷼',
    RMB: '￥',
    RON: 'lei',
    RSD: 'Дин.',
    RUB: '₽',
    RWF: 'R₣',
    SAR: '﷼',
    SBD: 'Si$',
    SCR: '₨',
    SDG: 'ج.س.',
    SEK: 'kr',
    SGD: '$',
    SHP: '£',
    SLL: 'Le',
    SOS: 'S',
    SRD: '$',
    SSP: '£',
    STD: 'Db',
    STN: 'Db',
    SVC: '₡',
    SYP: '£',
    SZL: 'E',
    THB: '฿',
    TJS: 'SM',
    TMT: 'T',
    TND: 'د.ت',
    TOP: 'T$',
    TRL: '₤',
    TRY: '₺',
    TTD: 'TT$',
    TVD: '$',
    TWD: 'NT$',
    TZS: 'TSh',
    UAH: '₴',
    UGX: 'USh',
    USD: '$',
    UYU: '$U',
    UZS: 'лв',
    VEF: 'Bs',
    VND: '₫',
    VUV: 'VT',
    WST: 'WS$',
    XAF: 'FCFA',
    XBT: 'Ƀ',
    XCD: '$',
    XOF: 'CFA',
    XPF: '₣',
    YER: '﷼',
    ZAR: 'R',
    ZWD: 'Z$'
};
const formatCurrency = (currency = 'RON') => currencyMap[currency];
